var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGolfers(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 52,
    height: 52,
    viewBox: "0 0 52 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 26,
    cy: 26,
    r: 26,
    fill: "#5F6F7C"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.4999 25.5C29.6947 25.5 32.2846 22.9256 32.2846 19.75C32.2846 16.5744 29.6947 14 26.4999 14C23.3051 14 20.7152 16.5744 20.7152 19.75C20.7152 22.9256 23.3051 25.5 26.4999 25.5ZM23.7621 25.742C21.5577 24.3935 18.6398 25.0149 17.6397 27.388C17.0874 28.6985 16.6376 30.1467 16.6017 31.4417C16.5791 32.2573 16.6439 33.1509 16.7401 33.9786C16.9469 35.7585 18.5246 37 20.3271 37H32.6728C34.4753 37 36.053 35.7585 36.2598 33.9786C36.356 33.1509 36.4208 32.2573 36.3982 31.4417C36.3623 30.1467 35.9125 28.6985 35.3602 27.388C34.3601 25.0149 31.4422 24.3935 29.2378 25.742L29.0264 25.8712C27.477 26.819 25.5229 26.819 23.9735 25.8712L23.7621 25.742Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGolfers);
export default __webpack_public_path__ + "static/media/Golfers.9a5be682d17529f479508ceadedc7cb8.svg";
export { ForwardRef as ReactComponent };